import createReducer from "./reducer/reducer";
import { configureStore } from "@reduxjs/toolkit";
import rootSaga from "./rootSaga";
import createSagaMiddleware from "redux-saga";

const sagaMiddleware = createSagaMiddleware();
const reducer = createReducer();
const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
  devTools:
    window?.__REDUX_DEVTOOLS_EXTENSION__ &&
    window?.__REDUX_DEVTOOLS_EXTENSION__()
});

sagaMiddleware.run(rootSaga);
export default store;
